export const CREATE_SPECIALTY_REQUEST = 'CREATE_SPECIALTY_REQUEST';

export const UPDATE_SPECIALTY_REQUEST = 'UPDATE_SPECIALTY_REQUEST';

export const DELETE_SPECIALTY_REQUEST = 'DELETE_SPECIALTY_REQUEST';

